export const cookiebot = () => {
    const script = document.createElement('script');

    script.src = 'https://consent.cookiebot.com/uc.js';
    script.async = true;
    script.type = 'text/javascript';
    script.setAttribute('data-cbid', '1f5423c1-49aa-4de8-8dab-ab31882abc53');
    script.id = 'Cookiebot';

    document.head.appendChild(script);
};
